import React, { useEffect, useState, FC } from "react";
import { Row, Col, Table, Pagination } from "antd";
import { columns, dataSource } from "../../helpers/transfer.helper";
import { useGlobalState } from "../../context/Provider";
import { GetTransferList } from "../../api/transfer";
import ConfirmTransferModal from "../../components/confirmTransformModal";
import TableTotalCount from "../../components/tableTotalCount";

import {
  TrasferEditing,
  EditableRow,
} from "../../components/transferEditiong/transferEditing.component";

const Transfer: FC = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const [total, setTotal] = useState<number>(0);
  const [data, setData] = useState<any>([]);
  const [page, setPage] = useState<number>(1);
  const [visibleConfrimModal, setVisibleConfrimModal] =
    useState<boolean>(false);
  const [info, setInfo] = useState<any>({});
  const { langState, warehouserList }: any = useGlobalState();

  const lang = langState.locale;

  useEffect(() => {
    handleTransferApi();
  }, [page]);

  const components = {
    body: {
      cell: TrasferEditing,
      row: EditableRow,
    },
  };

  const handleTransferApi = () => {
    setLoading(true);
    const params = {
      SkipCount: (page - 1) * 40,
    };
    GetTransferList(params).then((res: any) => {
      setLoading(false);
      if (res.status === 200) {
        setData(dataSource(res.data.items));
        setTotal(res.data.totalCount);
      }
    });
  };

  const handleConfirm = (isApprove: boolean, id: string) => {
    setVisibleConfrimModal(true);
    setInfo({ isApprove, id });
  };

  const handleSave = (row: any) => {
    const newData = [...data];
    const index = newData.findIndex((item) => row.key === item.key);
    const item = newData[index];
    newData.splice(index, 1, { ...item, ...row });
    setData(newData);
  };
  const CT = columns(lang, handleConfirm, warehouserList.data).map(
    (col: any) => {
      if (!col.editable) {
        return col;
      }

      return {
        ...col,
        onCell: (record: any) => ({
          record,
          editable: col.editable,
          dataIndex: col.dataIndex,
          title: col.title,
          handleSave: handleSave,
        }),
      };
    }
  );

  return (
    <>
      <Row gutter={[0, 24]} justify="center">
        <Col span={23}>
          <Table
            components={components}
            columns={CT}
            dataSource={data}
            size="middle"
            pagination={false}
            scroll={{ x: 1100, y: "calc(100vh - 210px)" }}
            loading={loading}
            rowClassName={() => "editable-row"}
          />
        </Col>
        <Col span={23}>
          <Row justify="space-between" align="middle">
            <Col>
              <Pagination
                defaultCurrent={1}
                total={total}
                defaultPageSize={40}
                showSizeChanger={false}
                onChange={(number) => setPage(number)}
              />
            </Col>
            <Col>
              <TableTotalCount total={total} />
            </Col>
          </Row>
        </Col>
      </Row>
      <ConfirmTransferModal
        info={info}
        visible={visibleConfrimModal}
        setVisible={setVisibleConfrimModal}
      />
    </>
  );
};

export default Transfer;
